(function employeeFileCertificateDetailControllerDefinition() {
    'use strict';

    angular.module('EmployeeFileCertificate')
        .controller('EmployeeFileCertificateDetailController', [
            '$scope', '$state', 'errorsExtend', 'documentContainerService', 'containerTypeService', 'authExtend', 'adminContainerTypeService', '$window', 'certificateService', '$stateParams',
            function EmployeeFileCertificateDetailController($scope, $state, errors, documentContainerService, containerTypeService, authExtend, adminContainerTypeService, $window, certificateService, $stateParams) {

                $scope.load = function () {
                    $scope.continuePermission = authExtend.isInRole('CERTIFICATE CONTINUE');
                    $scope.processHistoryPermission = authExtend.isInRole('CERTIFICATE READ');
                    $scope.canEnable = authExtend.isInRole('ENABLE CERTIFICATE');

                    $scope.systemName = {
                        cuil: '_cuil',
                        name: '_nom',
                        lastName: '_ape',
                        legNumber: '_nroleg',
                        docType: '_tdocu',
                        docNumber: '_ndocu'
                    };
                    $scope.metadata = {
                        name: [],
                        lastName: [],
                        cuil: [],
                        legNumber: [],
                        docType: [],
                        docNumber: []
                    };

                    certificateService.getAll($stateParams.userId).then(function (result) {
                        $scope.certificados = result;
                    }, function (error) {
                        errors.showError(error);
                    });

                    $scope.loadContainerType();
                    $scope.loadDocumentContainer();
                };

                $scope.view = function (cert) {
                    $state.go('certificate-rrhh-detail', { id: cert.id });
                };

                $scope.stateEnable = function (element) {
                    if (element.enabled !== null || element.enabled !== 'undefined') {
                        if (element.enabled) {
                            certificateService.disableCertificate(element.id).then(function (result) {
                                element.enabled = false;
                            }, function (error) {
                                errors.showError(error);
                            });
                        }
                        else {
                            certificateService.enableCertificate(element.id).then(function (result) {
                                element.enabled = true;
                            }, function (error) {
                                errors.showError(error);
                            });
                        }
                    }
                };

                $scope.cancel = function () {
                    $window.history.back();
                };

                $scope.loadDocumentContainer = function () {
                    return documentContainerService.getTreeOf($stateParams.employeeFileId).then(function (result) {
                        if (result.length > 0) {
                            $scope.employeeFile = result[0];
                            for (var i = 0; i < $scope.employeeFile.metadatas.length; i++) {
                                switch ($scope.employeeFile.metadatas[i].metadataSystemName) {
                                    case $scope.systemName.cuil:
                                        $scope.metadata.cuil = $scope.employeeFile.metadatas[i];
                                        $scope.metadata.cuil.mask = '99-99999999-9';
                                        break;
                                    case $scope.systemName.name: $scope.metadata.name = $scope.employeeFile.metadatas[i]; break;
                                    case $scope.systemName.lastName: $scope.metadata.lastName = $scope.employeeFile.metadatas[i]; break;
                                    case $scope.systemName.legNumber: $scope.metadata.legNumber = $scope.employeeFile.metadatas[i]; break;
                                    case $scope.systemName.docType: $scope.metadata.docType = $scope.employeeFile.metadatas[i]; break;
                                    case $scope.systemName.docNumber: $scope.metadata.docNumber = $scope.employeeFile.metadatas[i]; break;
                                }
                            }
                        } else {
                            errors.show('NotFound');
                            $scope.cancel();
                        }
                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });
                };

                $scope.loadContainerType = function () {
                    adminContainerTypeService.getMetadataMappings(authExtend.getOrganizationRoot()).then(function (result) {
                        for (var i = 0; i < result.length; i++) {
                            if (result[i].sourceMetadataMapping.length > 0 && result[i].targetMetadataMapping.length > 0) {
                                $scope.containerType = result[i];
                            }
                        }
                        if ($scope.containerType) {
                            // Valido que tenga permisos para el tc
                            containerTypeService.isContainertypeInRole(['EMPLOYEEFILE READ', 'EMPLOYEEFILE WRITE', 'EMPLOYEEFILE ADM'], $scope.containerType.id).then(function (r) {
                                if (!r) {
                                    errors.showError('EDRTC');
                                    $scope.cancel();
                                }
                            }, function (error) {
                                errors.showError(error);
                                $scope.cancel();
                            });
                            $scope.containerType.targetMetadataMapping.forEach(function (item, index) {
                                if (item.metadataSystemName === $scope.systemName.cuil) {
                                    $scope.systemName.cuil = $scope.containerType.sourceMetadataMapping[index].metadataSystemName;
                                }
                                if (item.metadataSystemName === $scope.systemName.name) {
                                    $scope.systemName.name = $scope.containerType.sourceMetadataMapping[index].metadataSystemName;
                                }
                                if (item.metadataSystemName === $scope.systemName.lastName) {
                                    $scope.systemName.lastName = $scope.containerType.sourceMetadataMapping[index].metadataSystemName;
                                }
                                if (item.metadataSystemName === $scope.systemName.legNumber) {
                                    $scope.systemName.legNumber = $scope.containerType.sourceMetadataMapping[index].metadataSystemName;
                                }
                                if (item.metadataSystemName === $scope.systemName.docType) {
                                    $scope.systemName.docType = $scope.containerType.sourceMetadataMapping[index].metadataSystemName;
                                }
                                if (item.metadataSystemName === $scope.systemName.docNumber) {
                                    $scope.systemName.docNumber = $scope.containerType.sourceMetadataMapping[index].metadataSystemName;
                                }
                            });
                        }
                    });
                };

                $scope.load();
            }
        ]);
})();